import { bankInstance } from '../utils/axiosConfig'; // Import de l'instance axios

const BankService = {
    // Méthode pour créer une banque
    createBank: async (bank) => {
        try {
            const response = await bankInstance.post('/create', bank, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error in createBank:', error.message || error);
            throw error;
        }
    },

    // Méthode pour mettre à jour une banque
    updateBank: async (bank) => {
        try {
            const response = await bankInstance.put('/update', bank, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error in updateBank:', error.message || error);
            throw error;
        }
    },

    // Méthode pour supprimer une banque via son ID
    deleteBank: async (id) => {
        try {
            const response = await bankInstance.delete(`/delete/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error in deleteBank:', error.message || error);
            throw error;
        }
    },

    // Méthode pour récupérer toutes les banques
    getAllBanks: async () => {
        try {
            const response = await bankInstance.get('/findAll');
            return response.data;
        } catch (error) {
            console.error('Error in getAllBanks:', error.message || error);
            throw error;
        }
    },

    // Méthode pour récupérer une banque spécifique via son ID
    getBankById: async (id) => {
        try {
            const response = await bankInstance.get(`/find/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error in getBankById:', error.message || error);
            throw error;
        }
    },
};

export default BankService;